const uploadIp = 'http://y-guanjia.com/exam-portal-api'
// const uploadIp = ''
const imgIp = 'http://www.y-guanjia.com/exam-ossimg/'
// const imgIp = ''

export default {
  imgIp: imgIp,
  uploadIp: uploadIp
}